var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M44.14 0H5.86A5.87 5.87 0 0 0 0 5.86v38.28A5.87 5.87 0 0 0 5.86 50h38.28A5.87 5.87 0 0 0 50 44.14V5.86A5.87 5.87 0 0 0 44.14 0Zm1.95 44.14a1.96 1.96 0 0 1-1.95 1.95H33.01V30.18h6.03l1-6.06h-7.03v-4.2A2.88 2.88 0 0 1 35.94 17h4v-6.05h-4a8.98 8.98 0 0 0-8.98 9v4.18h-5.87v6.06h5.87v15.91H5.86a1.96 1.96 0 0 1-1.95-1.95V5.86A1.96 1.96 0 0 1 5.86 3.9h38.28a1.96 1.96 0 0 1 1.95 1.95Z","fill":"currentColor"})));
}

Facebook.defaultProps = {"viewBox":"0 0 50 50"};

module.exports = Facebook;

Facebook.default = Facebook;
